import React from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'

import colors from '@settings/styleSettings'
import Text from './Text'

const styles = {
  imageContainer: {
    display: 'flex',
    backgroundColor: colors.grayBackground,
    borderRadius: '12px',
  },
  title: {
    fontSize: 16,
    color: colors.strongGray,
    fontWeight: 'CircularStd-Bold',
  },
  required: {
    color: colors.strongRed,
    fontSize: 16,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: 22
  },

}

const CardImage = ({ title, image }) => {
  return (
    <div style={styles.container}>
      <div style={styles.labelContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.required}>*</Text>
      </div>
      <div style={styles.imageContainer}>
        <img src={`data:image/jpeg;base64,${image}`} alt={title} style={{ width: '100%', height: '210px', borderRadius: '12px' }} />
      </div>
    </div>
  )
}

CardImage.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

export default CardImage
